jQuery(document).ready(function ($) {

    $('.js-slider').slick({
        infinite: false,
        variableWidth: true,
        arrows: false
    });

    $('.js-gallery-image').slick({
        infinite: true,
        variableWidth: true,
        arrows: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    arrows: false
                }
            }
        ]

    });

    $('.js-mobile-nav').on('click', function () {
        $('body').toggleClass('mobile-nav--active');
    });
    $('.mobile-overlay').on('click', function () {
        $('body').removeClass('mobile-nav--active');
    });

    $('#mobile-search').on('click', function () {
        $('.search-form').toggleClass('active');
    });

    $('.js-close-search').on('click', function () {
        $('.search-form').removeClass('active');
    });

    $('.js-categories-menu').on('click', function (e) {
        $('.category-nav__content').toggleClass('active');
    });

    $(document).mouseup(function (e) {
        var container = $(".category-nav");

        // if the target of the click isn't the container nor a descendant of the container
        if (!container.is(e.target) && container.has(e.target).length === 0) {
            container.find(".category-nav__content").removeClass('active');
        }
    });

});